import axiosCommon from "../axios";
export function contactUsService(obj) {
  return axiosCommon.post(`/website/contact-us/`, obj);
}
export default { contactUsService };
